// extracted by mini-css-extract-plugin
export var askAiIcon = "_jw-9";
export var container = "_jw-0";
export var groupSeparator = "_jw-a";
export var highlight = "_jw-4";
export var resultIcon = "_jw-5";
export var resultItem = "_jw-7";
export var resultSubtitle = "_jw-3";
export var resultTitle = "_jw-2";
export var resultsList = "_jw-1";
export var searchGroup = "_jw-6";
export var selected = "_jw-8";